import React from "react";
import { Routes, Route, Navigate, } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../pages/superadmin/Dashboard";
import Branches from "../pages/superadmin/Branches";
import MembershipPlans from "../pages/superadmin/MembershipPlans";
import Members from "../pages/superadmin/Members";
import Payments from "../pages/superadmin/Payments";
import Matches from "../pages/superadmin/Matches";
import BranchEnquiries from "../pages/superadmin/BranchEnquiries";
import Reports from "../pages/superadmin/Reports";
import Settings from "../pages/superadmin/Settings";
import Masters from "../pages/superadmin/Masters";
import MasterList from "../pages/superadmin/MasterList";
function SuperAdminRoutes() {
    return (
        <Routes>
            <Route element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="branches" element={<Branches />} />
                <Route path="membership-plans" element={<MembershipPlans />} />
                <Route path="members" element={<Members />} />
                <Route path="payments" element={<Payments />} />
                <Route path="matches" element={<Matches />} />
                <Route path="enquiries" element={<BranchEnquiries />} />
                <Route path="reports" element={<Reports />} />
                <Route path="settings" element={<Settings />} />
                <Route path="masters" element={<Masters />} />
                <Route path="masters/:masterType" element={<MasterList />}/>
            </Route>

        </Routes>
    );
}

export default SuperAdminRoutes;